<template>
  <div>
    <div
      v-if="title === 'new'"
      class="new-logo"
    >
      新
    </div>
    <div
      v-if="title === 'vip'"
      class="vip-logo"
    >
      VIP
    </div>
    <div
      v-if="title === 'vip-film'"
      class="vip-logo-film"
    >
      VIP
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: '',
    },
  },
};
</script>

<style lang="css">
.new-logo {
  width: 16px;
  height: 16px;
  background: rgba(226, 43, 0, 1);
  border-radius: 3px;
  font-size: 12px;
  color: rgba(255, 255, 255, 1);
  text-align: center;
  line-height: 16px;
}
.vip-logo {
  font-size: 10px;
  color: rgba(255, 255, 255, 1);
  width: 21px;
  height: 13px;
  background: rgba(231, 187, 120, 1);
  border-radius: 3px;
  text-align: center;
  padding-top: 1px;
  line-height: 13px;
}
.vip-logo-film {
  width: 30px;
  height: 18px;
  background: rgba(231, 187, 120, 1);
  border-radius: 3px;
  font-size: 12px;
  font-weight: bold;
  color: rgba(255, 255, 255, 1);
  line-height: 18px;
  text-align: center;
}
</style>
